import { render, staticRenderFns } from "./AcquirerHeaderPreview.vue?vue&type=template&id=2bf9eb42&"
import script from "./AcquirerHeaderPreview.vue?vue&type=script&lang=js&"
export * from "./AcquirerHeaderPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports